import React from "react";
import { CopyDetails } from "./CopyDetails";

export const ProjectContinuity = ({ id }) => (
  <div className="project-continuity" data-testid={`${id}-project-continuity`}>
    <h2 style={{ color: "inherit", fontFamily: "'Fraunces', Georgia, serif", fontSize: 26, lineHeight: 1.3, marginBottom: 20 }}>From decision to delivery.</h2>
    <p>Tract assignments, GIS tracking, negotiations and closeout, with staffing matched to workload. Fieldwork requires separate authorization and permissions.</p>
    <p>Licensed survey, engineering, environmental and legal work stays with the appropriate professionals.</p>
    <CopyDetails id={`${id}-coordination`} title="Communication and coordination">
      <p>Onward coordinates land work, survey access and project reporting. Dedicated contact channels, documented follow-up and advance field notices can be scoped to the engagement. Notices confirm existing permission; they do not grant it.</p>
    </CopyDetails>
  </div>
);